import React from 'react';
import OurWork from '../components/User/OurWork/OurWork';

function OurWorkPage() {
  return (
    <>
      <OurWork  />
    </>
  );
}

export default OurWorkPage;